import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import InputError from "../../../Fields/InputError";
import { getFieldError } from "../../../../helpers/form";

const HiddenInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  outline: none;
  z-index: 1;
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  cursor: text;
`;

const DisplayBox = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

const DigitBox = styled.div`
  width: 50px;
  height: 60px;
  font-size: 18px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid ${props => (props.$focused ? "orange" : "#ccc")};
  line-height: 60px;
  background-color: #fff;
  transition: border-color 0.3s ease;
  user-select: none;
`;

const VerificationCodeField = ({ input, meta, error }) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  const [focusedIndex, setFocusedIndex] = useState(0);

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
    setValue(digits);
    input.onChange(digits);
    setFocusedIndex(digits.length < 6 ? digits.length : 5);
  };

  const handleBoxClick = (index) => {
    inputRef.current?.focus();
    setFocusedIndex(index);
  };

  const handleFocus = () => {
    setFocusedIndex(value.length < 6 ? value.length : 5);
  };

  const handleBlur = () => {
    setFocusedIndex(null);
  };

  useEffect(() => {
    setValue(input.value || '');
  }, [input.value]);

  return (
    <div>
      <Container onClick={() => inputRef.current?.focus()}>
        <DisplayBox>
          {Array.from({ length: 6 }).map((_, i) => (
            <DigitBox
              key={i}
              $focused={focusedIndex === i}
              onClick={() => handleBoxClick(i)}
            >
              {value[i] || ''}
            </DigitBox>
          ))}
        </DisplayBox>
        <HiddenInput
          type="tel"
          value={value}
          onChange={handleChange}
          ref={inputRef}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </Container>
      <InputError>{error || getFieldError(meta)}</InputError>
    </div>
  );
};

export default VerificationCodeField;
